import {  AfterViewInit, Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { ImageService } from '../services/image.service';

@Directive({
    selector: 'img[d-img-lazy]',
    standalone: false
})
export class LazyImgDirective implements  OnInit, OnDestroy, AfterViewInit {
  @Input('d-img-lazy') src!: string;
  
  private observer!: IntersectionObserver;
  private imagesToLoad:any[] = [];

  constructor(
    private vcRef: ViewContainerRef,
    private ele: ElementRef,
    private renderer : Renderer2,
    private imageService: ImageService
  ) {
  }

  ngOnInit(): void {
    console.log('lazy-img image', this.src);
    this.renderer.setAttribute(this.ele.nativeElement, 'd-img-lazy-src', this.src);
  }

  ngAfterViewInit(): void {
    const observedElement = this.vcRef.element.nativeElement;
    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if(entry.isIntersecting && !entry.target.hasAttribute('d-img-lazy-status')){
          console.log('lazy-img visible, queueing for load', entry.target);
          this.imageService.queue(entry.target);
        }
      }
    });
    this.observer.observe(observedElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

}